export function tooDocFlowVariableSelectItem(item) {
  return {
    label: item.label,
    value: item.name,
  }
}

export function toDocFlowVariableSelectItems(data) {
  return data.map(tooDocFlowVariableSelectItem)
}

export function getDocFlowVariableSearchApiParam(searchValue) {
  return searchValue ? { name: searchValue } : null
}
